import {Adapter} from "./adapter";
import {nextFrame} from "../Utils";

export default class AjaxAdapter extends Adapter {
    setup() {
        this._currentIndex = 0;
        this._srcs = [];
        this.dialog.items.forEach(item => {
            this._elements.push($('<div></div>'));
            this._srcs.push(item.src);
        });
    }

    /**
     * @param index {number}
     * @returns {AdapterItem}
     */
    getForIndex(index) {
        const src = this._srcs[index];
        const $element = this._elements[index];
        return {
            $el: $element,
            src: '',
            title: '',
            ready: () => {
                return new Promise((resolve, reject) => {
                    (async () => {
                        let resp = await fetch(src);
                        if (!resp.ok) {
                            reject();
                            return;
                        }
                        let text = await resp.text();
                        $element.html(text);
                        await nextFrame();
                        resolve($element[0]);
                    })();
                });
            }
        }
    }

}
